import api from '@/api';

const resource = 'gerencial/localexterno';

export default {
  listarLocaisExternos() {
    return api.get( `${resource}`);
  },
};
